import React from 'react';
type propT = {
  strokeColor?: string;
  size?: number;
};
const Icon = ({
  strokeColor,
  size = 16
}: propT) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" preserveAspectRatio="xMidYMid meet">
      <path d="M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM12 20.5C7.31 20.5 3.5 16.69 3.5 12C3.5 7.31 7.31 3.5 12 3.5C16.69 3.5 20.5 7.31 20.5 12C20.5 16.69 16.69 20.5 12 20.5Z" fill={strokeColor ? strokeColor : 'currentColor'} />
      <path d="M15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12Z" fill={strokeColor ? strokeColor : 'currentColor'} />
    </svg>;
};
export default Icon;